module.exports = __webpack_public_path__ + "static/img/kll.ee99c2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kll.png
// module id = HjDr
// module chunks = 0